<script>
export default {
    props: {
        isAutoWidth: Boolean,
        updateAll: Boolean
    },
    inject: ['AppForm', 'AppFormItem'],
    data() {
        return {
            computedWidth: 0
        }
    },
    mounted() {
        this.updateLabelWidth('update')
    },
    beforeDestroy() {
        this.updateLabelWidth('remove')
    },
    methods: {
        getLabelWidth() {
            if (this.$app && this.$app.firstElementChild) {
                const computedWidth = window.getComputedStyle(this.$app.firstElementChild).width
                return Math.ceil(parseFloat(computedWidth))
            }
            else {
                return 0
            }
        },
        updateLabelWidth(action = 'update') {
            if (
                this.$slots.default &&
                    this.isAutoWidth &&
                    this.$app.firstElementChild
            ) {
                if (action === 'update') {
                    this.computedWidth = this.getLabelWidth()
                }
                else if (action === 'remove') {
                    this.AppForm.deregisterLabelWidth(this.computedWidth)
                }
            }
        }
    },
    watch: {
        computedWidth(val, oldVal) {
            if (this.updateAll) {
                this.AppForm.registerLabelWidth(val, oldVal)
                this.AppFormItem.updateComputedLabelWidth(val)
            }
        }
    },
    render() {
        const slots = this.$slots.default
        if (!slots) return null
        if (this.isAutoWidth) {
            const autoLabelWidth = this.AppForm.autoLabelWidth
            const style = {}
            if (autoLabelWidth && autoLabelWidth !== 'auto') {
                style.width = autoLabelWidth
            }
            return (
                <div class="app-form-item__label-wrap" style={style}>
                    {slots}
                </div>
            )
        }
        else {
            return slots[0]
        }
    },
}
</script>
